/** "Updated Nov 4" for this year, "Updated Nov 4, 2025" for older dates; empty when there is no date. */
const formatUpdatedOn = (value, now = new Date()) => {
  /* Postgres text timestamps ("2026-11-04 05:19:31+00") need a T and a full offset to parse. */
  const date = new Date(
    String(value || '')
      .replace(' ', 'T')
      .replace(/([+-]\d\d)$/, '$1:00')
  );

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const options = date.getFullYear() === now.getFullYear() ? { month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric', year: 'numeric' };
  return `Updated ${date.toLocaleDateString('en-US', options)}`;
};

export default formatUpdatedOn;
